import { PermissionEnum, UserSubscription } from '@creditsights/api-ui-web';
import { ICONS } from '@creditsights/styleguide-web';
import { MY_CONTENT_ROUTES, ROUTES, USER_ROUTES } from '../../Base.constants';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import useFetchUserProfile from '../profile/useFetchUserProfile';

interface UseGetUserDropdownOptionsResult {
  userDropdownOptions: Array<{
    link?: string;
    title: string;
    dataTestId?: string;
    isEnabled?: boolean;
    isSeparated?: boolean;
    onClick?: () => void;
    isBold?: boolean;
    iconName?: ICONS;
    iconNameSUI?: string;
  }>;
}

export default (): UseGetUserDropdownOptionsResult => {
  const { data: userPermissions } = useFetchUserPermissions();
  const { data: profile } = useFetchUserProfile();
  const rpOnly = userPermissions?.userSubscription === UserSubscription.RP;

  const userDropdownOptions = [
    {
      dataTestId: 'email-pref-link',
      link: `${ROUTES.user}/${MY_CONTENT_ROUTES.emailPreferences}`,
      title: 'Email Preferences',
      isEnabled: !rpOnly && userPermissions?.hasAccessToStandardAlerts(),
    },
    {
      dataTestId: 'preferences-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.managePreferences}`,
      title: 'Interests',
      isEnabled: userPermissions?.hasAccessToMyContentPreferences(),
    },
    {
      dataTestId: 'watchlists-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.watchlists}`,
      title: 'Watchlists',
      isEnabled: userPermissions?.hasAccessToMyContentWatchlists(),
    },
    {
      dataTestId: 'articles-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.articles}`,
      title: 'Saved Articles',
      isEnabled: !rpOnly && userPermissions?.hasAccessToMyContentArticles(),
    },
    {
      dataTestId: 'searches-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.searches}`,
      title: 'Searches',
      isEnabled: userPermissions?.hasAccessToMyContentSearches(),
    },
    {
      dataTestId: 'user-management',
      link: `${ROUTES.userManagement}`,
      title: 'User Admin',
      isEnabled: userPermissions?.permissions.includes(PermissionEnum.UI_ADMIN_USER_ADMIN),
    },
    {
      dataTestId: 'profile-link',
      link: `${ROUTES.user}/${USER_ROUTES.profile}`,
      title: 'My Account',
      isEnabled: userPermissions?.hasAccessToProfile(),
      isSeparated: true,
      isBold: true,
      iconName: ICONS.Gear,
    },
    {
      dataTestId: 'logout-link',
      link: `${ROUTES.logout}`,
      title: 'Log Out',
      isBold: true,
      iconNameSUI: 'sign out',
    },
  ];
  return {
    userDropdownOptions: userPermissions && profile?.active ? [...userDropdownOptions] : [userDropdownOptions[7]],
  };
};
